module.exports = __webpack_public_path__ + "static/media/Eid_Eladha_portrait_en.f7b71686.jpg";